<div class="reset-container">
  <div class="reset-card">
    @if (isLoading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    @if (currentView === 'form') {
      <h2>Neues Passwort setzen</h2>
      <form [formGroup]="resetForm" (ngSubmit)="submitReset()" (submit)="$event.preventDefault()" novalidate>
        <mat-form-field appearance="outline">
          <mat-label>Neues Passwort</mat-label>
          <input matInput formControlName="newPassword" [type]="hidePassword ? 'password' : 'text'" autocomplete="new-password">
          <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (resetForm.get('newPassword')?.hasError('minlength')) {
            <mat-error>Mindestens 8 Zeichen erforderlich</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Passwort bestätigen</mat-label>
          <input matInput formControlName="confirmPassword" [type]="hideConfirm ? 'password' : 'text'" autocomplete="new-password">
          <button mat-icon-button matSuffix type="button" (click)="hideConfirm = !hideConfirm">
            <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (resetForm.hasError('passwordsMismatch') && resetForm.get('confirmPassword')?.touched) {
            <mat-error>Passwörter stimmen nicht überein</mat-error>
          }
        </mat-form-field>

        <button mat-raised-button color="primary" type="submit"
                [disabled]="resetForm.invalid || isLoading">
          Passwort speichern
        </button>
      </form>
    }

    @if (currentView === 'success') {
      <h2>Passwort erfolgreich geändert</h2>
      <p class="info-text">Du kannst dich jetzt mit deinem neuen Passwort anmelden.</p>
      <a mat-button routerLink="/login" class="back-link">Zum Login</a>
    }

    @if (currentView === 'error') {
      <h2>Fehler</h2>
      <div class="error-message">{{ errorMessage }}</div>
      <a mat-button routerLink="/login" class="back-link">Zum Login</a>
    }
  </div>
</div>
